<template>
    <svg id="Isolation_Mode" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.33 19.37">
        <path fill="#5FE0B8" class="cls-1" d="m4.09,18.22h2.96c.43,0,.77-.29.74-.64l-.54-4.66c-.04-.39.4-.7.89-.62l2.52.41c.57.09,1.04-.34.84-.77L6.19.38c-.24-.52-1.18-.51-1.4.02L.04,12.11c-.18.45.35.88.92.74l2.07-.51c.51-.13,1.01.2.96.62l-.63,4.62c-.05.35.29.65.73.65Z"/>
    </svg>
</template>

